export enum Criticality {
    Information = 10,
    Warning = 20,
    Severe = 30,
    Critical = 40
}
